import {Injectable, inject} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, Router, UrlTree} from '@angular/router';

@Injectable({providedIn: 'root'})
export class forwardMappGuard implements CanActivate {
  private router: Router = inject(Router);

  public canActivate(route: ActivatedRouteSnapshot): UrlTree {
    const param1 = route.paramMap.get('param1') ?? '0';
    const param3 = route.paramMap.get('param3') ?? '0';
    // Forward to /knowledgebase/:param1/:param3
    return this.router.createUrlTree(['/knowledgebase', param1, param3]);
  }
}
